import PrimeVue from "primevue/config";

//PrimeVue
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";

export default PrimeVue;
